export default () => {
    return (
        <div style={{padding: '0 10px'}}>
            <h3>快背中医隐私政策</h3>
            <p></p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;本应用尊重并保护所有使用服务用户的个人隐私权。为了给您提供更为完善的产品服务，本应用会按照本隐私权政策的规定使用和披露您的个人信息。但本应用将以高度的勤勉、审慎义务对待这些信息。除本隐私权政策另有规定外，在未征得您事先许可的情况下，本应用不会将这些信息对外披露或向第三方提供。本应用会不时更新本隐私权政策。
                您在同意本应用服务使用协议之时，即视为您已经同意本隐私权政策全部内容。本隐私权政策属于本应用服务使用协议不可分割的一部分。</p>
            <p></p>
            <p>1.信息收集</p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;(a)
                在您使用本应用的服务，本应用自动接收并记录的您的设备上的信息，包括您的IP地址、设备类型、系统语言、访问日期和时间、读写SD卡数据。</p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;(b) 我们的产品集成友盟+SDK，友盟+SDK需要收集您的设备Mac地址、唯一设备识别码（IMEI/android
                ID/IDFA/OPENUDID/GUID/IP地址/SIM 卡 IMSI
                信息）以提供统计分析服务，并通过地理位置校准报表数据准确性，提供基础反作弊能力。</p>
            <p>2.信息使用</p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;(a)
                本应用不会向任何无关第三方提供、出售、出租、分享或交易您的个人信息，除非事先得到您的许可，或该第三方和本应用（含本应用关联公司）单独或共同为您提供服务，且在该服务结束后，其将被禁止访问包括其以前能够访问的所有这些资料。</p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;(b)
                本应用亦不允许任何第三方以任何手段收集、编辑、出售或者无偿传播您的个人信息。任何本应用平台用户如从事上述活动，一经发现，本应用有权立即终止与该用户的服务协议。</p>
            <p></p>
            <p>3.信息披露</p>
            <p>在如下情况下，本应用将依据您的个人意愿或法律的规定全部或部分的披露您的个人信息：</p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;(a) 经您事先同意，向第三方披露；</p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;(b) 为提供您所要求的产品和服务，而必须和第三方分享您的个人信息；</p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;(c)
                根据法律的有关规定，或者行政或司法机构的要求，向第三方或者行政、司法机构披露；</p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;(d)
                如您出现违反中国有关法律、法规或者本应用服务协议或相关规则的情况，需要向第三方披露；</p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;(e)
                如您是适格的知识产权投诉人并已提起投诉，应被投诉人要求，向被投诉人披露，以便双方处理可能的权利纠纷；</p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;(f) 其它本应用根据法律、法规或者网站政策认为合适的披露。</p>
            <p></p>
            <p>4.信息存储和交换</p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;本应用收集的有关您的信息和资料将保存在本应用及（或）其关联公司的服务器上，这些信息和资料可能传送至您所在国家、地区或本应用收集信息和资料所在地的境外并在境外被访问、存储和展示。</p>
            <p></p>
            <p>5.本隐私政策的更改</p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;(a)如果决定更改隐私政策，本应用会在本政策中、本公司网站中以及本应用认为适当的位置发布这些更改，以便您了解本应用如何收集、使用您的个人信息，哪些人可以访问这些信息，以及在什么情况下本应用会透露这些信息。</p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;(b)本公司保留随时修改本政策的权利，因此请经常查看。如对本政策作出重大更改，本公司会通过网站通知的形式告知。</p>
            <p></p>
            <p>6.如何联系我们</p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;如果您对本隐私政策有任何疑问、意见或建议，您可以将相关内容发送至：1667469187@qq.com。我们收到您的问题后，将在十五个工作日内对您反馈的问题进行处理并及时向您答复。</p>
        </div>
    )
}